<template>
  <kst-page-export-details
    @init="handleInit"
    @export="handleExport"
  >
    <Export
      :userData="userData"
      @init="handleExport_Init"
    />

    <kst-check disabled
      v-model="userData.WithDetails"
      :label="Info.Export.Details.Excel.Option.Details"
    />

    <template v-if="access.Glob_HPP">
      <kst-check
        v-model="userData.WithHpp"
        :label="Info.Export.Details.Excel.Option.Hpp"
      />
    </template>
  </kst-page-export-details>
</template>

<script>
import Info from "../StrdInfo.js";
import Model from "../StrdModel.js";
import Services from "../../../services/Api/StockReductionServices.js";

import Export from "./StrdExD_Export.vue";

export default {
  components: {
    Export
  },
  data: () => ({
    Info: Info,
    access: {},
    userData: {
      ID: null,
      WithDetails: true,
      WithHpp: true,
    },
    // func
    exportExcelFunc: null
  }),
  methods: {
    /*** by page ***/

    handleInit(id) {
      this.resetData();
      this.userData.ID = id;
    },

    handleExport(loadExport) {
      const config = Services.getExportDetails(this.userData.ID);
      loadExport(config, this.handleExport_Success);
    },
    handleExport_Success(data, fileName) {
      this.exportExcelFunc(data, fileName);
    },

    /*** custom ***/

    resetData() {
      this.access = this.$kst.Access.create(Model.Access);

      this.userData.ID = null;
      this.userData.WithDetails = true;
      this.userData.WithHpp = this.access.Glob_HPP;
    },

    handleExport_Init(exportExcel) {
      this.exportExcelFunc = exportExcel;
    }
  }
}
</script>